import { createSlice } from '@reduxjs/toolkit'
import {getFactoryBagGroups, getFactoryModalityBag, getFactoryModalityPool, getFactoryModalityTypeDaysYear} from "./thunks"
import { logOut } from '../authentication/authenticationSlice';

const initialState= { 
  bagGroups: [], 
  loading: "idle",
  error: null }

const factoryBagGroupsSlice = createSlice({
  name: 'factoryBagGroups',
  initialState,
  reducers: {
    clearBagError: (state)=>{
      state.error = null
      state.loading = "idle"
    }
  },
  extraReducers: {
    [getFactoryModalityBag.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
      },
    [getFactoryModalityBag.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.bagGroups = action.payload
      
    },
    [getFactoryModalityBag.rejected]: (state, action) => {
        state.loading = "failed"; 
        state.error = action.error.message
      },
    [getFactoryModalityPool.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
      },
    [getFactoryModalityPool.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.bagGroups = action.payload
      
    },
    [getFactoryModalityPool.rejected]: (state, action) => {
        state.loading = "failed"; 
        state.error = action.error.message
      },
    [getFactoryModalityTypeDaysYear.pending]: (state) => {
        state.loading = "loading"; 
        state.error = null
      },
    [getFactoryModalityTypeDaysYear.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.bagGroups = action.payload
      
    },
    [getFactoryModalityTypeDaysYear.rejected]: (state, action) => {
        state.loading = "failed"; 
        state.error = action.error.message
      }, 
    [logOut]: (state)=> initialState
  }
})

export const {clearBagError} = factoryBagGroupsSlice.actions;
export default factoryBagGroupsSlice.reducer
